import {
  $fontSize,
  $height,
  $marginLeft,
  $paddingX,
  $right,
  $width,
  phoneSize,
} from '@/assets/styles/mediaSize';
import { flexPos } from '@/assets/styles/mixin';
import { FC, ReactNode } from 'react';
import { styled } from 'styled-components';
import { callFromExternal } from '@/utils';
import { getValue } from '@/externalConfig/conf'
interface INewMsgTipsProps {
  show: boolean;
  className?: string;
  children: ReactNode;
  onClick?: () => void;
}

const ScrollToButtomWrap = styled.div`
  &.block {
    position: absolute;
    background-color: #0054fc1a;
    backdrop-filter: blur(14px);
    border-radius: 12rem 12rem 0 12rem;
    cursor: pointer;

    ${$height('72rem', '36rem')}
    ${flexPos('space-between', 'center')}
    ${$paddingX('24rem', '16rem')}
    ${$fontSize('28rem', '14rem')}

  .icon-arrow {
      transform: rotate(-90deg);
      ${$marginLeft('16rem', '8rem')}
      ${$width('32rem', '16rem')}
    }

    right: 0;
    top: 0;
    transform: translate(-25rem, -50rem);

    @media (max-width: ${phoneSize}) {
      transform: translate(-30rem, -90rem);
    }
  }
`;
const external = callFromExternal()
const ScrollToButtom: FC<INewMsgTipsProps> = ({ className, children, show, onClick }) => {
  return (
    external ? show ? <img className='external-scrollto-bottom' src={getValue('scrollToBottomIcon')} width="34" onClick={() => onClick?.()}/> : '' :
    <ScrollToButtomWrap
      onClick={() => onClick?.()}
      className={`${className} ${show ? 'block' : 'hidden'}`}
    >
      <div>{children}</div>
      <img src={require('@img/common/icon-arrow.svg')} alt="" className="icon-arrow" />
    </ScrollToButtomWrap>
  );
};

export default ScrollToButtom;
